/* Quick View — Pablo Raez (Impact theme)
   The Quick View renders a native replica of the product page (product-gallery +
   product-info), so the gallery/variant behaviour is the theme's own tested code.
   The only thing the theme can't do on its own: the <quick-buy-drawer> injects the
   fetched PDP content via replaceChildren(template.content), and injected <script>
   tags never execute — so third-party widgets (Loox) that ran their one-time scan on
   page load don't paint the freshly-injected rating. Re-init Loox after the drawer
   opens and after a variant re-render. Loaded once, globally. */
(function () {
  if (window.__prQuickViewInit) return;
  window.__prQuickViewInit = true;

  // Re-scan Loox for a freshly injected widget. Loox's API has shifted across
  // versions, so try each known entry point defensively; poll while it loads.
  function reloadLoox(scope) {
    var root = scope || document;
    if (!(root.querySelector && root.querySelector('#looxReviews, .loox-rating, .loox-widget, [class*="loox"]'))) return;
    var attempts = 0;
    (function tryReload() {
      var loox = window.loox;
      if (loox) {
        try { if (typeof loox.reload === 'function') { loox.reload(); return; } } catch (e) {}
        try {
          if (loox.widgets && loox.widgets.rating && typeof loox.widgets.rating.load === 'function') {
            loox.widgets.rating.load(); return;
          }
        } catch (e) {}
      }
      try { document.dispatchEvent(new CustomEvent('loox:widgets:load')); } catch (e) {}
      if (!loox && attempts < 20) { attempts++; setTimeout(tryReload, 150); }
    })();
  }

  function isQvDrawer(el) {
    return el && el.tagName === 'QUICK-BUY-DRAWER' && el.classList && el.classList.contains('pr-qv-drawer');
  }

  // The Trustpilot review widget is a Swiper carousel. When the drawer injects the
  // fetched PDP HTML, the Swiper markup comes with a frozen inline transform (a
  // snapshot of wherever the live PDP slider happened to be) but NO Swiper instance —
  // so it shows a random mid slide ("backwards"). Reset the wrapper to the first slide.
  function fixSwipers(drawer) {
    drawer.querySelectorAll('.swiper .swiper-wrapper').forEach(function (w) {
      w.style.transitionDuration = '0ms';
      w.style.transform = 'translate3d(0px, 0px, 0px)';
    });
  }

  // Fires after the drawer's open transition — content is already injected.
  // Capture phase because the drawer is re-parented to <body> while open.
  document.addEventListener('dialog:after-show', function (e) {
    if (!isQvDrawer(e.target)) return;
    var drawer = e.target;
    reloadLoox(drawer);
    // The frozen Swiper transform can be present immediately or applied a beat later,
    // so reset it a few times over the first ~1.5s to reliably catch it.
    [0, 120, 300, 600, 1000, 1500].forEach(function (t) {
      setTimeout(function () { fixSwipers(drawer); }, t);
    });
  }, true);

  // A variant change partially re-renders the buy-box, so re-init the rating too.
  function onVariant(e) {
    var t = e.target;
    var drawer = t && t.closest ? t.closest('quick-buy-drawer.pr-qv-drawer') : null;
    if (drawer) setTimeout(function () { reloadLoox(drawer); fixSwipers(drawer); }, 120);
  }
  document.addEventListener('variant:change', onVariant, true);
  document.addEventListener('product:rerender', onVariant, true);

  // ---- Cart line-item quantity steppers (+/-) ----
  // The theme's <quantity-selector> buttons set input.quantity WITHOUT firing a
  // change event, so on the cart they'd update the number but not the cart. Our
  // buttons set the value AND dispatch a bubbling 'change', which <line-item-quantity>
  // listens for to POST /cart/change. Delegated on document → survives cart re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pr-qty]');
    if (!btn) return;
    var wrap = btn.closest('.pr-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var dir = parseInt(btn.getAttribute('data-pr-qty'), 10) || 0;
    var before = parseInt(input.value, 10) || 1;
    // input is the theme's QuantityInput element; its .quantity setter clamps to min/max.
    try { input.quantity = before + dir; }
    catch (err) { input.value = String(Math.max(1, before + dir)); }
    if ((parseInt(input.value, 10) || 1) !== before) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
